import client from './client'

export default {
  getShopItem: (item) => {
    return new Promise((resolve, reject) => {
      client.get('https://www.hideki.co.jp/api/shop/', { params: { category: item } })
        .then(res => resolve({ results: res.data }))
        .catch(err => {
          reject(new Error(err.response.data.message || err.message))
        })
    })
  }
}
